import React from "react";
import DHButtonIcon from "./DHButtonIcon";
import ModeEditIcon from '@mui/icons-material/ModeEdit';

export default function DHButtonIconPencil({ disabled, onClick}) {

    return <DHButtonIcon icon={<ModeEditIcon/>} disabled={disabled} onClick={onClick}/>
}